<template lang="pug">
.v-field-translate-list.field-translate-list(:class="{'field-check-list--disabled': field.disabled}, field.className")
	label.field-translate-list__label(v-if="field.label" :id="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-translate-list__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
		v-field-checkbox(
			:true-value="option.auto"
			:text="option.text"
			:number="option?.number"
			:icon="option?.icon"
			:disabled="option.disabled || field.disabled"
			:radio="radio"
			:type="field?.type"
			:lang="option?.lang"
			:model-value="localValue.find(item => item.lang === option.lang)?.auto"
			@update:model-value="handleInput")
		v-field-text(
			:field="option"
			:type="field?.type"
			:class="{'hidden': localValue.find(item => item.lang === option.lang)?.auto}"
			:model-value="localValue.find(item => item.lang === option.lang)?.value"
			@update:model-value="handleInput")
		.field-translate-list__error(v-if="option.error" ) {{ option.error }}
		.field-translate-list__note(v-if="option.note" ) {{ option.note }}
	.field-translate-list__error(v-if="field.error" ) {{ field.error }}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: [],
			checkboxValue: [],
			open: false,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput(value) {
			if(this.localValue.length) {
				if(this.localValue.every(item => item.lang !== value.lang)) {
					this.localValue.push(value);
				}

				if(Object.keys(value).some(key => key === 'value')) {
					this.localValue.forEach(item => {
						if(item.lang === value.lang) {
							item.value = value.value
						}
					})
				}

				if(Object.keys(value).some(key => key === 'auto')) {
					this.localValue.forEach(item => {
						if(item.lang === value.lang) {
							item.auto = value.auto
						}
					})

					this.checkboxValue.forEach(item => {
						if(item.lang === value.lang) {
							item.auto = value.auto
						}
					})
				}
			} else {

				if(Object.keys(value).some(key => key === 'auto')) {
					this.checkboxValue.forEach(item => {
						if(item.lang === value.lang) {
							item.auto = value.auto
						}
					})
				}
				this.localValue.push(value);
			}
			this.$emit('update:model-value', this.localValue);
		}
	},
};
</script>
